import { render, staticRenderFns } from "./OnlineClass.vue?vue&type=template&id=4d66b9a3&scoped=true&"
import script from "./OnlineClass.vue?vue&type=script&lang=js&"
export * from "./OnlineClass.vue?vue&type=script&lang=js&"
import style0 from "./OnlineClass.vue?vue&type=style&index=0&id=4d66b9a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d66b9a3",
  null
  
)

export default component.exports